import axios from "axios";

export const state = {
    reportdiagnosisanalysis: [],
};

export const getters = {
    reportdiagnosisanalysis: state => state.reportdiagnosisanalysis,
};

export const mutations = {
    setReportDiagnosisAnalysis(reportdiagnosisanalysis, newValue) { state.reportdiagnosisanalysis = newValue},
};

export const actions = {
    fetchReportDiagnosisAnalysis({ commit }) {
        axios.get('/reportdiagnosisanalysis').then(res => {
            commit('setReportDiagnosisAnalysis', res.data.diagnoses)
        })
    },
    filterReportDiagnosisAnalysis({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportdiagnosisanalysis";
        axios.post(url, formData).then((response) => {
            commit('setReportDiagnosisAnalysis', response.data.diagnoses)
        })
    },
};
